/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {WelcomeEmailCustomization} from '../models/WelcomeEmailCustomization';

export interface GetWelcomeEmailCustomizations$Request {
    accountId: number;
}

export interface GetWelcomeEmailCustomizations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getWelcomeEmailCustomizationsRequest = createAction<PayloadData<void, GetWelcomeEmailCustomizations$Request>>('GET_WELCOME_EMAIL_CUSTOMIZATIONS__GET_WELCOME_EMAIL_CUSTOMIZATIONS__REQUEST');
export const getWelcomeEmailCustomizationsSuccess = createAction<PayloadData<WelcomeEmailCustomization, GetWelcomeEmailCustomizations$Request>>('GET_WELCOME_EMAIL_CUSTOMIZATIONS__GET_WELCOME_EMAIL_CUSTOMIZATIONS__SUCCESS');
export const getWelcomeEmailCustomizationsFailure = createAction<PayloadData<Error, GetWelcomeEmailCustomizations$Request, true>>('GET_WELCOME_EMAIL_CUSTOMIZATIONS__GET_WELCOME_EMAIL_CUSTOMIZATIONS__FAILURE');

export const getWelcomeEmailCustomizationsActions = [
    getWelcomeEmailCustomizationsRequest,
    getWelcomeEmailCustomizationsSuccess,
    getWelcomeEmailCustomizationsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getWelcomeEmailCustomizations = (meta: GetWelcomeEmailCustomizations$Request, config?: GetWelcomeEmailCustomizations$Config) => {
    return {
        CALL_API: {
            types: getWelcomeEmailCustomizationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/welcome-email-customizations`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

